import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private isDevelopment = !environment.production;

  debug(message: string, ...optionalParams: unknown[]): void {
    if (this.isDevelopment) {
      // eslint-disable-next-line no-console
      console.debug(message, ...optionalParams);
    }
  }

  log(message: string, ...optionalParams: unknown[]): void {
    if (this.isDevelopment) {
      // eslint-disable-next-line no-console
      console.log(message, ...optionalParams);
    }
  }

  warn(message: string, ...optionalParams: unknown[]): void {
    if (this.isDevelopment) {
      // eslint-disable-next-line no-console
      console.warn(message, ...optionalParams);
    }
    // In production can send to logging service
  }

  error(message: string, error?: unknown): void {
    if (this.isDevelopment) {
      // eslint-disable-next-line no-console
      console.error(message, error);
    }
    // In production send to error monitoring service
    this.sendErrorToMonitoringService(message, error);
  }

  private sendErrorToMonitoringService(_message: string, _error?: unknown): void {
    // TODO: Implement error monitoring service integration
    // For example, Sentry, LogRocket, or custom API
  }
}
